interface SearchLocationTranslationModel {
    locationPlaceholder: string;
}

const defaultSearchLocationTranslation: Required<SearchLocationTranslationModel> = {
    locationPlaceholder: 'Wpisz miasto lub region',
};

export { type SearchLocationTranslationModel, defaultSearchLocationTranslation };
